import { useContext, useRef } from 'react';
import { Box } from '@mantine/core';
import SingleCustomerContext from '../Customer-Context/SingleCustomerContext';
import IdeaDetails from '../Customer-Table/Right-card/IdeaDetails';
import CustomersAccordions from './CustomersAccordions';

function CustomDrawerCustomers() {

  const drawerRef = useRef<HTMLDivElement>(null);

  const { cardOpened, chosenIdea
  } = useContext(SingleCustomerContext);


  const isIdea = chosenIdea?.status !== 'evidence'
  
  /* useClickOutside(() => {
    if (cardOpened) {
      setCardOpened(false);
      setActivityOpened(false);
    }
  }, null, [drawerRef.current]); */

  return (
    <Box
      ref={drawerRef}
      bg='#fff'
      sx={(theme) => ({
        position: 'fixed',
        top: 63,
        right: cardOpened ? 0 : '-620px' ,
        width:  620 ,
        height: 'calc(100vh - 63px)',
        backgroundColor: theme.colors.gray[0],
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        /* transition: 'right 0.05s ease', */ 
        zIndex: 1000,
      })}
    >
      
      <>
        {isIdea && <IdeaDetails />}
        
        <CustomersAccordions />
        {/* <DemoAccordions /> */}
      </>
      
      {/* <SideBar navToPerspective={null} setActiveSearch={null} reviewMode componentType={'customer'}/> */}
    </Box>
  );
}

export default CustomDrawerCustomers;